<template>
  <div class="search-out-view">
    <h6>筛选条件</h6>
    <div class="search-view">
      <div
        class="search-button"
        v-for="(item, index) in SearchTitle"
        :key="index"
      >
        <a
          :class="[item.active ? 'active p-24-6' : 'p-24-6']"
          @click="HeaderClick(item, index)"
        >
          {{ item.name }}
          <b-icon icon="chevron-down" v-if="item.icon"></b-icon>
          <b-icon icon="chevron-up" v-else></b-icon>
        </a>
      </div>
    </div>
    <div class="search-content" v-if="show">
      <div class="search-content-title">
        <h5>{{ Title }}</h5>
        <a @click="cleanButton">清除</a>
      </div>
      <!-- 项目类型 -->
      <div class="search-context" v-if="type == 'area'">
        <div
          :class="[categoriesId == items.code ? 'active p-24-6' : 'p-24-6']"
          @click="ContentCLick(items, indexs)"
          v-for="(items, indexs) in SearchContent"
          :key="indexs"
        >
          <a>{{ items.name }}</a>
        </div>
        <div v-if="More" @click="MoreClick" class="p-24-6">
          <a>{{ MoreText }}</a>
        </div>
      </div>
      <div class="search-context" v-else>
        <div
          :class="[categoriesId == items.id ? 'active p-24-6' : 'p-24-6']"
          @click="ContentCLick(items, indexs)"
          v-for="(items, indexs) in SearchContent"
          :key="indexs"
        >
          <a>{{ items.name }}</a>
        </div>
        <div v-if="More" @click="MoreClick" class="p-24-6">
          <a>{{ MoreText }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "search",
  props: {
    cleanButton: {
      type: Function
    },
    //更多
    More: {
      type: Boolean,
      default: false
    },
    MoreText: {
      type: String,
      default: "更多"
    },
    MoreClick: {
      type: Function
    },
    SearchTitle: {
      type: Array
    },
    Title: {
      type: String
    },
    SearchContent: {
      type: Array,
      default: function() {
        return [];
      }
    },
    ContentCLick: {
      type: Function
    },
    show: {
      type: Boolean,
      default: false
    },
    HeaderClick: {
      type: Function
    },
    categoriesId: {
      type: Number
    },
    type: {
      type: String
    },
    //返回数据
    handleChange: {
      type: Function
    }
  }
};
</script>
<style scoped></style>
